export default "__VITE_ASSET__CO$r_tbc__"